import { render, staticRenderFns } from "./button-options.vue?vue&type=template&id=054b012a&scoped=true"
import script from "./button-options.vue?vue&type=script&lang=js"
export * from "./button-options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054b012a",
  null
  
)

export default component.exports